import React from 'react'
import './FallbackLoaderStyle.css';

const FallbackLoader = () => {
  return (
    <div className='gradientLoader'></div>
  )
}

export default FallbackLoader